import React, { act } from "react";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";

const MBDialog = ({
  openModel,
  closeModel,
  title,
  children,
  actionBtns,
  fullWidth,
  maxWidth = "sm",
}) => {
  return (
    <Dialog
      fullWidth={fullWidth}
      open={openModel}
      onClose={closeModel}
      maxWidth={maxWidth}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title" sx={{ maxHeight: "15px" }} mb={2}>
        {title} <CloseIcon onClick={closeModel} sx={{ cursor: "pointer", float: "right" }} />
      </DialogTitle>

      <DialogContent>{children}</DialogContent>
      {actionBtns && (
        <>
          <Divider />
          <DialogActions>
            <SoftButton variant="contained" color="dark" onClick={closeModel}>
              {t("lang.actions.close")}
            </SoftButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

MBDialog.propTypes = {
  title: PropTypes.string,
  openModel: PropTypes.bool.isRequired,
  closeModel: PropTypes.func.isRequired,
  children: PropTypes.node,
  actionBtns: PropTypes.bool,
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.string,
};
MBDialog.defaultProps = {
  actionBtns: false,
};

export default MBDialog;
